export default "__VITE_ASSET__DRQzUaS5__"